import React from "react";
import { useParams } from "react-router-dom";
import AuctionPage from "./AuctionPage";

export default function ItemDetail() {
  const { slug } = useParams();

  return (
    <div className="container mx-auto px-4 py-8">
      <AuctionPage slug={slug} />
    </div>
  );
}
